import $ from 'jquery';

const CONTAINER_SELECTOR = '.product-list, .featured-product';

$(function() {
    $(CONTAINER_SELECTOR).on('mouseover', '.js-product', (e)=> {
        const $card = e.currentTarget;
        $card.classList.add('hover');
    });

    $(CONTAINER_SELECTOR).on('mouseout', '.js-product', (e)=> {
        const $card = e.currentTarget;
        $card.classList.remove('hover');
    });

    $(CONTAINER_SELECTOR).on('focusin', '.js-product', (e)=> {
        const $card = e.currentTarget;
        $card.classList.add('hover');
    });

    $(CONTAINER_SELECTOR).on('blur', '.js-product', (e)=> {
        const $card = e.currentTarget;
        $card.classList.remove('hover');
    });

    // Product gallery hover navigation (featured-product-grid-hover)
    document.querySelectorAll('.js-product-gallery').forEach((gallery) => {
        const images = gallery.querySelectorAll('.featured-product-grid-hover__gallery-img');
        const dots = gallery.querySelectorAll('.featured-product-grid-hover__gallery-dot');
        if (images.length <= 1) return;

        // Show first image by default
        images[0]?.classList.add('is-active');
        dots[0]?.classList.add('is-active');

        const showImage = (index: number) => {
            images.forEach((img) => img.classList.remove('is-active'));
            dots.forEach((dot) => dot.classList.remove('is-active'));
            images[index]?.classList.add('is-active');
            dots[index]?.classList.add('is-active');
            (gallery as HTMLElement).setAttribute('data-current', String(index));
        };

        gallery.querySelector('.js-gallery-prev')?.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
            showImage(current > 0 ? current - 1 : images.length - 1);
        });

        gallery.querySelector('.js-gallery-next')?.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
            showImage(current < images.length - 1 ? current + 1 : 0);
        });
    });
  // Product gallery hover navigation (featured-product-grid-wf)
document.querySelectorAll('.js-product-gallery').forEach((gallery) => {
    const images = gallery.querySelectorAll('.featured-product-grid-wf__gallery-img');
    const dots = gallery.querySelectorAll('.featured-product-grid-wf__gallery-dot');
    if (images.length <= 1) return;

    images[0]?.classList.add('is-active');
    dots[0]?.classList.add('is-active');

    const showImage = (index: number) => {
        images.forEach((img) => img.classList.remove('is-active'));
        dots.forEach((dot) => dot.classList.remove('is-active'));
        images[index]?.classList.add('is-active');
        dots[index]?.classList.add('is-active');
        (gallery as HTMLElement).setAttribute('data-current', String(index));
    };

    gallery.querySelector('.js-gallery-prev')?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
        showImage(current > 0 ? current - 1 : images.length - 1);
    });

    gallery.querySelector('.js-gallery-next')?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
        showImage(current < images.length - 1 ? current + 1 : 0);
    });
});
  // Product gallery hover navigation (fpg-two-rf)
  document.querySelectorAll('.js-product-gallery').forEach(gallery => {
    const links = gallery.querySelectorAll('.fpg-two-rf__product-img a');
    const dots = gallery.querySelectorAll('.fpg-two-rf__gallery-dot');
    if (links.length <= 1) return;

    links[0]?.classList.add('is-active');
    dots[0]?.classList.add('is-active');

    const showImage = (index: number) => {
      links.forEach((link) => link.classList.remove('is-active'));
      dots.forEach((dot) => dot.classList.remove('is-active'));
      links[index]?.classList.add('is-active');
      dots[index]?.classList.add('is-active');
      (gallery as HTMLElement).setAttribute('data-current', String(index));
    };

    gallery.querySelector('.js-gallery-prev')?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
      showImage(current > 0 ? current - 1 : links.length - 1);
    });

    gallery.querySelector('.js-gallery-next')?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
      showImage(current < links.length - 1 ? current + 1 : 0);
    });
  });
  // ── Left-feature 4-product variant (featured-product-grid-lf__) ──
document.querySelectorAll('.featured-product-grid-lf .js-product-gallery').forEach((gallery) => {
  const links = gallery.querySelectorAll('.featured-product-grid-lf__product-img a');
  const dots = gallery.querySelectorAll('.featured-product-grid-lf__gallery-dot');
  const total = links.length;
  if (total < 2) return;

  const showImage = (index: number) => {
    links.forEach((link) => link.classList.remove('is-active'));
    dots.forEach((dot) => dot.classList.remove('is-active'));
    links[index]?.classList.add('is-active');
    dots[index]?.classList.add('is-active');
    (gallery as HTMLElement).setAttribute('data-current', String(index));
  };

  // Init first
  showImage(0);

  gallery.querySelector('.js-gallery-prev')?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
    showImage((current - 1 + total) % total);
  });

  gallery.querySelector('.js-gallery-next')?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
    showImage((current + 1) % total);
  });
});

// ── Left-feature 2-product variant (fpg-two-lf__) ──
document.querySelectorAll('.fpg-two-lf .js-product-gallery').forEach((gallery) => {
  const links = gallery.querySelectorAll('.fpg-two-lf__product-img a');
  const dots = gallery.querySelectorAll('.fpg-two-lf__gallery-dot');
  const total = links.length;
  if (total < 2) return;

  const showImage = (index: number) => {
    links.forEach((link) => link.classList.remove('is-active'));
    dots.forEach((dot) => dot.classList.remove('is-active'));
    links[index]?.classList.add('is-active');
    dots[index]?.classList.add('is-active');
    (gallery as HTMLElement).setAttribute('data-current', String(index));
  };

  showImage(0);

  gallery.querySelector('.js-gallery-prev')?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
    showImage((current - 1 + total) % total);
  });

  gallery.querySelector('.js-gallery-next')?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
    showImage((current + 1) % total);
  });
});
  // — Slider four-grid hover variant (slider-products-four-grid-hover__) —
document.querySelectorAll('.slider-products-four-grid-hover .js-product-gallery').forEach((gallery) => {
  const links = gallery.querySelectorAll('.slider-products-four-grid-hover__product-img a');
  const dots = gallery.querySelectorAll('.slider-products-four-grid-hover__gallery-dot');
  const total = links.length;
  if (total < 2) return;

  const showImage = (index: number) => {
    links.forEach((link) => link.classList.remove('is-active'));
    dots.forEach((dot) => dot.classList.remove('is-active'));
    links[index]?.classList.add('is-active');
    dots[index]?.classList.add('is-active');
    (gallery as HTMLElement).setAttribute('data-current', String(index));
  };

  showImage(0);

  gallery.querySelector('.js-gallery-prev')?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
    showImage((current - 1 + total) % total);
  });

  gallery.querySelector('.js-gallery-next')?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
    showImage((current + 1) % total);
  });
});
// — Slider six-grid hover variant (slider-products-six-grid-hover__) —
document.querySelectorAll('.slider-products-six-grid-hover .js-product-gallery').forEach((gallery) => {
  const links = gallery.querySelectorAll('.slider-products-six-grid-hover__product-img a');
  const dots = gallery.querySelectorAll('.slider-products-six-grid-hover__gallery-dot');
  const total = links.length;
  if (total < 2) return;

  const showImage = (index: number) => {
    links.forEach((link) => link.classList.remove('is-active'));
    dots.forEach((dot) => dot.classList.remove('is-active'));
    links[index]?.classList.add('is-active');
    dots[index]?.classList.add('is-active');
    (gallery as HTMLElement).setAttribute('data-current', String(index));
  };

  showImage(0);

  gallery.querySelector('.js-gallery-prev')?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
    showImage((current - 1 + total) % total);
  });

  gallery.querySelector('.js-gallery-next')?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
    showImage((current + 1) % total);
  });
});

      // — Elegant left-feature 4-product variant (featured-product-grid-elf__) —
    document.querySelectorAll('.featured-product-grid-elf .js-product-gallery').forEach((gallery) => {
      const links = gallery.querySelectorAll('.featured-product-grid-elf__product-img a');
      const dots = gallery.querySelectorAll('.featured-product-grid-elf__gallery-dot');
      const total = links.length;
      if (total < 2) return;

      const showImage = (index: number) => {
        links.forEach((link) => link.classList.remove('is-active'));
        dots.forEach((dot) => dot.classList.remove('is-active'));
        links[index]?.classList.add('is-active');
        dots[index]?.classList.add('is-active');
        (gallery as HTMLElement).setAttribute('data-current', String(index));
      };

      // Init first
      showImage(0);

      gallery.querySelector('.js-gallery-prev')?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
        showImage((current - 1 + total) % total);
      });

      gallery.querySelector('.js-gallery-next')?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
        showImage((current + 1) % total);
      });
    });
  
      // — Elegant right-feature 4-product variant (featured-product-grid-erf__) —
    document.querySelectorAll('.featured-product-grid-erf .js-product-gallery').forEach((gallery) => {
      const links = gallery.querySelectorAll('.featured-product-grid-erf__product-img a');
      const dots = gallery.querySelectorAll('.featured-product-grid-erf__gallery-dot');
      const total = links.length;
      if (total < 2) return;

      const showImage = (index: number) => {
        links.forEach((link) => link.classList.remove('is-active'));
        dots.forEach((dot) => dot.classList.remove('is-active'));
        links[index]?.classList.add('is-active');
        dots[index]?.classList.add('is-active');
        (gallery as HTMLElement).setAttribute('data-current', String(index));
      };

      // Init first
      showImage(0);

      gallery.querySelector('.js-gallery-prev')?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
        showImage((current - 1 + total) % total);
      });

      gallery.querySelector('.js-gallery-next')?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
        showImage((current + 1) % total);
      });
    });

      // — Elegant left-feature 2-product variant (fpg-two-elf__) —
    document.querySelectorAll('.fpg-two-elf .js-product-gallery').forEach((gallery) => {
      const links = gallery.querySelectorAll('.fpg-two-elf__product-img a');
      const dots = gallery.querySelectorAll('.fpg-two-elf__gallery-dot');
      const total = links.length;
      if (total < 2) return;

      const showImage = (index: number) => {
        links.forEach((link) => link.classList.remove('is-active'));
        dots.forEach((dot) => dot.classList.remove('is-active'));
        links[index]?.classList.add('is-active');
        dots[index]?.classList.add('is-active');
        (gallery as HTMLElement).setAttribute('data-current', String(index));
      };

      showImage(0);

      gallery.querySelector('.js-gallery-prev')?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
        showImage((current - 1 + total) % total);
      });

      gallery.querySelector('.js-gallery-next')?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
        showImage((current + 1) % total);
      });
    });

  // ── Two-Grid Elegant Right Feature (fpg-two-erf) ──
document.querySelectorAll('.fpg-two-erf .js-product-gallery').forEach((gallery) => {
  const prefix = 'fpg-two-erf__';
  const anchors = gallery.querySelectorAll(`.${prefix}product-img a`);
  const dots = gallery.querySelectorAll(`.${prefix}gallery-dot`);
  const prevBtn = gallery.querySelector(`.${prefix}nav-btn--prev`);
  const nextBtn = gallery.querySelector(`.${prefix}nav-btn--next`);
  let current = 0;
  const total = anchors.length;

  if (total <= 1) return;

  function goTo(index: number) {
    anchors.forEach((a, i) => {
      a.classList.toggle('is-active', i === index);
    });
    dots.forEach((d, i) => {
      d.classList.toggle('is-active', i === index);
    });
    current = index;
  }

  prevBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    goTo((current - 1 + total) % total);
  });

  nextBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    goTo((current + 1) % total);
  });

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => goTo(i));
  });
});

  // ── Featured Product Grid (products-four-grid-bar) ──
document.querySelectorAll('.featured-product-grid .js-product-gallery').forEach((gallery) => {
  const links = gallery.querySelectorAll('.featured-product-grid__product-img a');
  const dots = gallery.querySelectorAll('.featured-product-grid__gallery-dot');
  const total = links.length;
  if (total < 2) return;

  const showImage = (index: number) => {
    links.forEach((link) => link.classList.remove('is-active'));
    dots.forEach((dot) => dot.classList.remove('is-active'));
    links[index]?.classList.add('is-active');
    dots[index]?.classList.add('is-active');
    (gallery as HTMLElement).setAttribute('data-current', String(index));
  };

  showImage(0);

  gallery.querySelector('.js-gallery-prev')?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
    showImage((current - 1 + total) % total);
  });

  gallery.querySelector('.js-gallery-next')?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const current = parseInt((gallery as HTMLElement).getAttribute('data-current') || '0', 10);
    showImage((current + 1) % total);
  });
});

});
